import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertCircle, XCircle, AlertTriangle, Info } from "lucide-react";

/**
 * Modal genérico para exibir erros do backend
 *
 * @param {boolean} open - Controla se o modal está aberto
 * @param {function} onClose - Callback chamado ao fechar o modal
 * @param {string} title - Título do erro
 * @param {string} message - Mensagem detalhada do erro
 * @param {string} type - Tipo do erro: 'error', 'warning', 'info' (padrão: 'error')
 * @param {function} onConfirm - Callback opcional para ação de confirmação
 * @param {string} confirmText - Texto do botão de confirmação (padrão: 'Entendi')
 */
export function ErrorModal({
  open = false,
  onClose,
  title = "Erro",
  message = "Ocorreu um erro inesperado.",
  type = "error",
  onConfirm,
  confirmText = "Entendi",
}) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case "warning":
        return <AlertTriangle className="h-6 w-6 text-terra" />;
      case "info":
        return <Info className="h-6 w-6 text-primary" />;
      case "error":
      default:
        return <XCircle className="h-6 w-6" style={{ color: "#1b5e20" }} />;
    }
  };

  const getIconBgColor = () => {
    switch (type) {
      case "warning":
        return "bg-terra-soft";
      case "info":
        return "bg-secondary";
      case "error":
      default:
        return "bg-red-100";
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className={`p-2 rounded-full ${getIconBgColor()}`}>
              {getIcon()}
            </div>
            <AlertDialogTitle className="text-lg font-semibold">
              {title}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base text-gray-700">
            {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleConfirm}
            style={{ background: "#1b5e20" }}
            className="hover:opacity-90"
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ErrorModal;
